import React, { Fragment } from "react";
import Header from "../components/Header";
import PageHeader from "../components/PageHeader";
import Careers from "../components/Policy";
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
import SEO from "../components/SEO";

import CarrerList from "../data/Policy";

const PolicyPage = () => {
  let carrerData = CarrerList[0];
  let contentTitle = "PRIVACY POLICY";

  return (
    <Fragment>
      <SEO />
      <Header />
      <PageHeader
        bgImg={require("../assets/img/careers-bg-1.jpg")}
        title={contentTitle}
        content=""
      />
      <Careers carrerData={carrerData} />
      <Footer />
      <MobileMenu />
    </Fragment>
  );
};

export default PolicyPage;
